import ajax from '@/utils/ajax'

/**
 * 语音播报服务
 */

// 更新播报状态播报
export const updateBroadcastStatus = params => ajax.post('/broadcast/updateBroadcastStatus', params)

// 获取开启的账号列表
export const openAccount = params => ajax.post('/broadcast/openAccount', params)

// 播放字段
export const broadcastField = params => ajax.post('/broadcast/broadcastField', params)

// 按频率查询未播放的订单
export const getFailVoiceOrder = params => ajax.post('/broadcast/getFailVoiceOrder', params)
